import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { addQuality, removeQuality, setContentSource } from 'Pods/SearchPage/Store/actions/qualityContent'
import { QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { qualityFiltersConfig, contentSourceFiltersConfig } from './constants'

const DEFAULT_QUALITY = [QUALITY_LEVEL.ANY]

const stripLabels = groups => groups.map(group => ({ ...group, label: '' }))

function QualityContent({ hideGroupLabels = false }) {
  const quality = useSearchPageStore(state => state.quality ?? DEFAULT_QUALITY)
  const contentSource = useSearchPageStore(state => state.contentSource ?? CONTENT_SOURCE.ALL)

  const handleQualityFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      addQuality(value)
    } else {
      removeQuality(value)
    }
  }, [])

  const handleContentSourceFilterChange = useCallback((_, value) => {
    setContentSource(value)
  }, [])

  const qualityConfig = useMemo(
    () => (hideGroupLabels ? stripLabels(qualityFiltersConfig) : qualityFiltersConfig),
    [hideGroupLabels],
  )
  const contentSourceConfig = useMemo(
    () => (hideGroupLabels ? stripLabels(contentSourceFiltersConfig) : contentSourceFiltersConfig),
    [hideGroupLabels],
  )

  const selectedContentSource = useMemo(() => [contentSource], [contentSource])

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={qualityConfig}
        selectedFilters={quality}
        onFiltersChange={handleQualityFilterChange}
        isControlled
        useNewCheckboxes
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={contentSourceConfig}
        selectedFilters={selectedContentSource}
        onFiltersChange={handleContentSourceFilterChange}
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
        useRadio
      />
    </>
  )
}

QualityContent.propTypes = {
  hideGroupLabels: bool,
}

export default memo(QualityContent)
